import {
  T2, Tile, P, media, IconButton, TileProps, T2Props, ExternalLink, IconButtonProps,
} from 'ia-react-core';
import { ButtonHTMLAttributes, FC } from 'react';
import styled from 'styled-components';

export const StyledTile = styled<FC<TileProps>>(Tile) <{ hide: boolean; backgroundColor: string }>`
 background-color:${({ backgroundColor }) => backgroundColor};
  background-repeat: no-repeat;
  border-radius: 4px;
  background-size: 500px;
  display: flex;
  padding: 36px 16px;
  margin-top: 36px;
  box-shadow: none;
  ${media.xs`
    display: block;
  `}
  ${media.sm`
  @media screen and (min-width: 794px) {
    display: flex;
    background-position:350px;
    flex-direction: inherit;
    padding: 36px 32px;
  }
  `}
  ${media.lg`
    background-position:250px;
    padding: 36px 26px 36px 26px;
  `}

  ${media.xl`
    background-position:250px;
    padding: 36px 26px 36px 26px;
  `}

  ${({ hide }) => hide && `
    display: none;
  `}
 `;

export const StyledCloseButton = styled<FC<IconButtonProps & ButtonHTMLAttributes<HTMLButtonElement>>>(IconButton)`
  color: ${({ theme }) => theme.colors.blue5};
  &:hover {
    color: ${({ theme }) => theme.colors.blue10};
  }
  &:active {
    color: ${({ theme }) => theme.colors.blue3};
  }
  position: absolute;
  right: 0px;
  top: 0;
`;

export const StyledIconsDiv = styled.div`
  display: flex;
  align-items: center;
  min-width: fit-content;
  flex-grow: 100;
  padding: 0 0 17px 0;

  ${media.sm`
  @media screen and (min-width: 794px) {
    padding: 0 16px;
    justify-content: end;
    align-items: center;
  }
  `}

  ${media.md`
    padding: 0 0 0 16px;
  `}
`;

export const StyledT = styled<FC<T2Props>>(T2)`
  color: ${({ theme }) => theme.colors.blue6};
  font-weight: 800;
  line-height: 1.17;
  margin-bottom: 16px;
`;

export const StyledP = styled(P)`
  line-height: 1.29;
  font-weight: 600;
  margin-bottom: 0;
`;

export const StyledLink = styled(ExternalLink)`
  font-weight: inherit;
  text-decoration: underline;

  &:hover {
    text-decoration: inherit;
  }
  &:active {
    text-decoration: inherit;
  }
`;
